var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    fill: "#c94d4c",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1a46f",
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1a46f",
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40352e",
    opacity: 1,
    d: "M509.542+87.3482C601.742+81.6426+699.377+170.199+716.642+298.273C716.704+314.395+709.609+314.778+692.066+312.792C660.364+309.203+626.72+305.195+582.313+299.572C571.582+298.213+553.131+196.256+553.131+196.256C553.131+196.256+557.622+297.622+543.616+298.166C532.934+298.582+465.257+297.829+454.167+298.869C445.841+299.65+454.167+192.741+454.167+192.741C454.167+192.741+429.187+299.487+421.814+300.275C389.888+303.686+310.045+314.155+312.7+295.355C330.462+169.548+411.539+93.4129+509.542+87.3482Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent8);
export default __webpack_public_path__ + "static/media/Student 8.5575a6f6efc8a7c20bb8e00defe02d1e.svg";
export { ForwardRef as ReactComponent };